import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import CreateAdminForm from 'components/Admins/CreateAdminForm';
import { useDispatch, useSelector } from 'react-redux';
import { AdminTypeProps, State } from 'store/admins/types';
import { fetchClubs, setStrategy } from 'store/admins/actions';
import { admins } from 'routes/routePaths';
import { createStrategy } from 'pages/Admins/utils/strategyFactory';

const AdminsRegister: React.FC<RouteComponentProps> = ({ history }: RouteComponentProps) => {
  const { clubs }: State = useSelector((state: any) => state.adminsReducer);
  const [error, setError] = useState<string>('');
  const dispatch = useDispatch();

  const handleSubmit = async (values: AdminTypeProps) => {
    try {
      const strategy = createStrategy(values);
      dispatch(setStrategy(strategy));
      history.push(admins.companyDetails);
    } catch (error) {
      setError('Unable to go next.');
    }
  };

  useEffect(() => {
    dispatch(fetchClubs());
  }, [dispatch]);

  return (
    <>
      <h2 className="page-title">Admin Registration</h2>
      <CreateAdminForm onSubmit={handleSubmit} error={error} clubs={clubs} />
    </>
  );
};

export default AdminsRegister;
